<template>
  <component :is="routedComponent"></component>
</template>

<script>

import QuantityDiscountComponent from "./QuantityDiscount.vue";
import BlockDiscountComponent from "./BlockDiscount.vue";

export default {
  name: "DiscountRouterComponent",
  computed: {
    routedComponent() {
      if (this.isQuantityDiscount()) {
        console.log("Loading QuantityDiscount Component");
        return QuantityDiscountComponent;
      } else if (this.isBlockDiscount()) {
        console.log("Loading BlockDiscount Component");
        return BlockDiscountComponent;
      } else {
        console.log("Loading Default Component");
        return QuantityDiscountComponent;
      }
    }
  },

  methods: {
    isQuantityDiscount() {
      return this.$one.context.meta?.type == "QUANTITY";
    },
    isBlockDiscount() {
      return this.$one.context.meta?.type == "BLOCK";
    },
  }
}

</script>